import React from 'react';
import { injectIntl, FormattedHTMLMessage } from 'react-intl'
import './EarningsGraph.css';
import brass from '../../../resources/assets/images/earningscalculator/Ic_Brance.svg'
import silver from '../../../resources/assets/images/earningscalculator/Ic_Plata.svg'
import golden from '../../../resources/assets/images/earningscalculator/IC_Oro.svg'
import zaphir from '../../../resources/assets/images/earningscalculator/Ic_Zafiro.svg'
import diamond from '../../../resources/assets/images/earningscalculator/Ic_diamante.svg'

function PureEarningsGraph({intl}) {

  const text = {
    graphTitle: intl.formatMessage({ id: 'graphTitle' }),

    brass: intl.formatMessage({ id: 'brass' }),
    brassPercent: intl.formatMessage({ id: 'brassPercent' }),

    silver: intl.formatMessage({ id: 'silver' }),
    silverPercent: intl.formatMessage({ id: 'silverPercent' }),

    golden: intl.formatMessage({ id: 'golden' }),
    goldenPercent: intl.formatMessage({ id: 'goldenPercent' }),

    zaphir: intl.formatMessage({ id: 'zaphir' }),
    zaphirPercent: intl.formatMessage({ id: 'zaphirPercent' }),

    diamond: intl.formatMessage({ id: 'diamond' }),
    diamondPercent: intl.formatMessage({ id: 'diamondPercent' }),

    graphCompany: intl.formatMessage({ id: 'graphCompany' }),
  }

  return (
    <div className="containerGraph">
      <div className="boxGraph">
        <strong>{text.graphTitle}</strong>
        <div className="graphFlex">
          
          <div className="graphBox brass">
            <span>{text.brass}</span>
            <img alt={text.brass} src={brass} />
            <h6>{text.brassPercent}</h6>
            <small>{text.graphCompany}</small>
          </div>

          <div className="graphBox silver">
            <span>{text.silver}</span>
            <img alt={text.silver} src={silver} />
            <h6>{text.silverPercent}</h6>
            <small>{text.graphCompany}</small>
          </div>

          <div className="graphBox golden">
            <span>{text.golden}</span>
            <img alt={text.golden} src={golden} />
            <h6>{text.goldenPercent}</h6>
            <small>{text.graphCompany}</small>
          </div>

          <div className="graphBox zaphir">
            <span>{text.zaphir}</span>
            <img alt={text.zaphir} src={zaphir} />
            <h6>{text.zaphirPercent}</h6>
            <small>{text.graphCompany}</small>
          </div>

          <div className="graphBox diamond">
            <span>{text.diamond}</span>
            <img alt={text.diamond} src={diamond} />
            <h6>{text.diamondPercent}</h6>
            <small>{text.graphCompany}</small>
          </div>

        </div>
      </div>
      <p className="paragraph">
        {<FormattedHTMLMessage id='graphParagraph' />}
      </p>
    </div>
  );
}

const EarningsGraph = (
  injectIntl(PureEarningsGraph)
)

export default EarningsGraph;
